import { useContext } from 'react';
import { element } from '../../../core/elements';
import { XYCHART_EVENT_SOURCE } from '../../common/events/constants';
import TooltipContext from '../../common/events/context/TooltipContext';
import useEventEmitters from '../../common/events/hooks/useEventEmitters';
import usePointerEventHandlers from '../../common/events/hooks/useEventHandlers';
import { useLineData } from '../providers/data';

/** Public props */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const LineTooltipOverlayElement = element(props => {
  const {
    tooltipOpen,
    showTooltip,
    hideTooltip,
    tooltipData,
    width,
    height,
    xScale,
    yScale,
    colorScale,
    xAccessor,
    colorAccessor,
    margin,
    yAccessor,
    seriesData,
    data,
    onClick
  } = props;
  const eventEmitters = useEventEmitters({
    source: XYCHART_EVENT_SOURCE
  });
  usePointerEventHandlers({
    dataKey: 'nearest',
    onPointerMove: d => showTooltip(d),
    onPointerOut: () => hideTooltip(),
    onPointerDown: d => onClick && onClick(d),
    allowedSources: [XYCHART_EVENT_SOURCE],
    width,
    margin,
    height,
    data,
    xScale,
    yScale,
    xAccessor,
    yAccessor,
    seriesData
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [tooltipOpen && (tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.nearestSeriesData) && /*#__PURE__*/_jsx(_Fragment, {
      children: tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.nearestSeriesData.map(d => {
        var _xScale, _yScale;
        return /*#__PURE__*/_jsx("circle", {
          cx: (_xScale = xScale(xAccessor(d))) !== null && _xScale !== void 0 ? _xScale : 0,
          cy: (_yScale = yScale(yAccessor(d))) !== null && _yScale !== void 0 ? _yScale : height,
          fill: colorScale(colorAccessor(d)),
          r: 5
        }, xScale(xAccessor(d)) + '-' + xAccessor(d) + '-' + colorAccessor(d));
      })
    }), /*#__PURE__*/_jsx("rect", {
      style: {
        cursor: onClick ? 'pointer' : 'default'
      },
      width: width,
      height: height,
      fill: "transparent",
      ...eventEmitters
    })]
  });
});
export function LineTooltipOverlay() {
  const {
    width,
    height,
    xScale,
    yScale,
    xAccessor,
    colorAccessor,
    colorScale,
    yAccessor,
    seriesData,
    margin,
    data
  } = useLineData();
  const {
    showTooltip,
    tooltipData,
    tooltipOpen,
    hideTooltip
  } = useContext(TooltipContext);
  return /*#__PURE__*/_jsx(LineTooltipOverlayElement, {
    tooltipOpen: tooltipOpen,
    showTooltip: showTooltip,
    hideTooltip: hideTooltip,
    tooltipData: tooltipData,
    width: width,
    height: height,
    xScale: xScale,
    yScale: yScale,
    xAccessor: xAccessor,
    colorScale: colorScale,
    colorAccessor: colorAccessor,
    yAccessor: yAccessor,
    margin: margin,
    seriesData: seriesData,
    data: data
  });
}